import {Box, Button, Container, Dialog, DialogActions, DialogContent, DialogTitle, Typography} from "@mui/material";
import {useEffect, useRef, useState} from "react";
import {green} from "../../Utils/style";
import {NODE_ROUTE_URI, PARTNER_URI} from "../../Utils/apiUrl";
import axios from "axios";
import {
    CAR_SHIPPING,
    checkAPICallLimit,
    convertDataFromServiceCode, convertMovingItemsToPackageData, CUSTOMS_BROKERAGE, HS_CODE_LOOKUP, isValidatePhone,
    LTL_FREIGHT,
    MOVING_SERVICE,
    PARCEL_PACKAGE
} from "../../Utils/Helper";
import {WordPressMultiConversationChatBotOutput} from "./WordPressMultiConversationChatBotOutput";
import {WordPressMultiConversationChatBotInput} from "./WordPressMultiConversationChatBotInput";
import {useParams} from "react-router-dom";

export const WordPressMultiConversationChatBot = () => {

    const {lng} = useParams();

    const chatContainerRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [service, setService] = useState(null);
    const [chatHistory, setChatHistory] = useState([]);
    const [status, setStatus] = useState(0); // 0 initial, 1 complete, 2 confirm, 3 rate
    const [emailAddress, setEmailAddress] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [apiCheck, setAPICheck] = useState(null);
    const [listData, setListData] = useState([]);
    const [movingFrom, setMovingFrom] = useState(null);
    const [movingTo, setMovingTo] = useState(null);
    const [movingInformation, setMovingInformation] = useState(null);
    const [APIRate, setAPIRate] = useState(null);
    const [language, setLanguage] = useState('en');
    const [openLanguage, setOpenLanguage] = useState(false);
    const [packageRate, setPackageRate] = useState(null);
    const [packageLoading, setPackageLoading] = useState(false);
    const [packageError, setPackageError] = useState(false);
    const [isAbleGetPackageRate, setIsAbleGetPackageRate] = useState(false);

    const handleLanguageDialogClose = () => {
        setOpenLanguage(false);
    };

    const handleLanguageDialogOpen = () => {
        setOpenLanguage(true);
    };

    const handleSelectLanguage = (selectsLanguage) => {
        setLanguage(selectsLanguage);
        handleLanguageDialogClose();
    }

    const hasChinesePreference = () => {
        const CHINESE_PREFIX = 'zh';

        // Check if navigator and languages are available
        if (navigator && navigator.languages) {
            // 1. Get the array of all preferred languages
            const languages = navigator.languages;

            // 2. Use .some() to check if at least one element meets the condition
            return languages.some(lang =>
                // Convert to lowercase and check if it starts with 'zh'
                lang.toLowerCase().startsWith(CHINESE_PREFIX)
            );
        }

        // Return false if the feature is unsupported or no languages are listed
        return false;
    };

    const handleMultiConversationChatBot = async (chatData, systemRole = null) => {
        try {
            setLoading(true);
            const requestURL = `${NODE_ROUTE_URI}/deepSeek/admin/multiConversationChatBot`;

            const mappedChatData = chatData?.map(chat => ({
                role: chat?.role,
                parts: chat?.data ? [
                    {
                        text: `${JSON.stringify(chat.data)} ${chat?.parts?.[0]?.text}`
                    }
                ] : chat?.parts
            }))

            const data = {
                systemRole: systemRole || service?.code,
                chatHistory: mappedChatData,
                lng: language
            }

            const result = await axios({
                method: 'post',
                url: requestURL,
                data: data
            });

            console.log('[handleMultiConversationChatBot] result', result);

            setStatus(result?.data?.status);
            setMovingFrom(result?.data?.shipper_address);
            setMovingTo(result?.data?.consignee_address);

            switch (systemRole || service?.code) {
                case PARCEL_PACKAGE?.code:
                    setListData(result?.data?.package);
                    break
                case LTL_FREIGHT?.code:
                    setListData(result?.data?.pallet);
                    break
                case MOVING_SERVICE?.code:
                    // await handleConvertToItemList();
                    setListData(result?.data?.item);
                    setMovingInformation(result?.data);
                    break;
                case CAR_SHIPPING?.code:
                    setListData(result?.data?.vehicle);
                    break;
                default:
                    setListData([]);
            }
            return result?.data;
        } catch (e) {
            console.log('[handleMultiConversationChatBot] error', e);
        } finally {
            setLoading(false);
        }
    }

    const validateEmailAddress = async (email) => {
        let requestURL = `${NODE_ROUTE_URI}/validateEmail`;
        try {
            const result = await axios({
                method: 'post',
                url: requestURL,
                data: {
                    email: email,
                    validateRegex: true,
                    validateMx: true,
                    validateTypo: false,
                    validateDisposable: false,
                    validateSMTP: false
                }
            })
            console.log('[validateEmailAddress] result - ', result);
            return result?.data;
        } catch (e) {
            console.log(e.response)
        }
    }

    const handleGetPackageRating = async (email, phone) => {
        try {
            setLoading(true);
            let requestURL = `${PARTNER_URI}/loose-item/3rd-party/partner/rates/landing/all`;

            let packageList = listData?.map(each => ({
                length: each?.length,
                height: each?.height,
                width: each?.width,
                quantity: each?.quantity,
                weight: each?.weight,
                lengthUnit: each?.dimension_unit,
                weightUnit: each?.weight_unit,
            }));

            const data = {
                rateData: {
                    shipFromAddress: "",
                    shipFromAddressTwo: "",
                    shipFromSubCity: movingFrom?.subCity,
                    shipFromCity: movingFrom?.city,
                    shipFromProvince: movingFrom?.province,
                    shipFromPostalCode: movingFrom?.postalCode,
                    shipFromCountry: movingFrom?.country,
                    shipFromName: "",
                    shipFromPhone: "",
                    shipToAddress: "",
                    shipToAddressTwo: "",
                    shipToSubCity: movingTo?.subCity,
                    shipToCity: movingTo?.city,
                    shipToPostalCode: movingTo?.postalCode,
                    shipToProvince: movingTo?.province,
                    shipToCountry: movingTo?.country,
                    shipToName: "",
                    shipToPhone: "",
                    packageData: packageList,
                },
                sendNotifyEmail: true,
                userEmail: email,
                userPhone: phone,
                chatBot: true
            }

            const result = await axios({
                method: 'post',
                url: requestURL,
                data: data
            })

            setAPIRate(result?.data);

            return result?.data;

        } catch (e) {
            setError(true);
        } finally {
            setLoading(false);
        }
    }

    // const getLTLQuoteByDeepSeek = async () => {
    //     try {
    //         setLoading(true);
    //         let requestURL = `${PARTNER_URI}/shippingLTL/getLTLQuoteByDeepSeek`;
    //
    //         let palletList = listData?.map(each => ({
    //             length: each?.length,
    //             height: each?.height,
    //             width: each?.width,
    //             quantity: each?.quantity,
    //             weight: each?.weight,
    //             lengthUnit: each?.dimension_unit,
    //             weightUnit: each?.weight_unit,
    //         }));
    //
    //         const data = {
    //             shipFromCity: movingFrom?.city,
    //             shipFromProvince: movingFrom?.province,
    //             shipFromCountry: movingFrom?.country,
    //             shipFromPostalCode: movingFrom?.postalCode,
    //             shipToCity: movingTo?.city,
    //             shipToProvince: movingTo?.province,
    //             shipToCountry: movingTo?.country,
    //             shipToPostalCode: movingTo?.postalCode,
    //             transitMode: [
    //                 "rail",
    //                 "road",
    //                 "Intermodal"
    //             ],
    //             accountBase: "Vitran",
    //             packageData: palletList,
    //             sendNotifyEmail: true,
    //             userEmail: email,
    //             userPhone: phoneNumber,
    //             systemRole: "LTL_RATING"
    //         }
    //
    //         const result = await axios({
    //             method: 'post',
    //             url: requestURL,
    //             data: data
    //         })
    //
    //         console.log('[getLTLQuoteByDeepSeek] result', result);
    //
    //         // setAIRate(result?.data?.ltlQuote);
    //         // setLTLRateFromAI(result?.data?.ltlQuote);
    //
    //     } catch (e) {
    //         console.log('error', e?.response);
    //         setError(true);
    //     } finally {
    //         setLoading(false);
    //     }
    // }

    const handleGetLTLRating = async (email, phone) => {
        try {
            setLoading(true);
            let requestURL = `${PARTNER_URI}/shippingLTL/LTLShippingRatingForLanding`;

            let palletList = listData?.map(each => ({
                length: each?.length,
                height: each?.height,
                width: each?.width,
                quantity: each?.quantity,
                weight: each?.weight,
                lengthUnit: each?.dimension_unit,
                weightUnit: each?.weight_unit,
            }));

            const data = {
                shipperAddress: "",
                shipperAddressType: "warehouse",
                shipperSubCity: movingFrom?.subCity,
                shipperCity: movingFrom?.city,
                shipperProvince: movingFrom?.province,
                shipperPostalCode: movingFrom?.postalCode,
                shipperCountry: movingFrom?.country,
                consigneeAddress: "",
                consigneeAddressType: "warehouse",
                consigneeSubCity: movingTo?.subCity,
                consigneeCity: movingTo?.city,
                consigneeProvince: movingTo?.province,
                consigneePostalCode: movingTo?.postalCode,
                consigneeCountry: movingTo?.country,
                packageData: palletList,
                sendNotifyEmail: true,
                userEmail: email,
                userPhone: phone,
                chatBot: true
            }

            const result = await axios({
                method: 'post',
                url: requestURL,
                data: data
            })

            console.log('[handleGetLTLRating] result', result);

            // todo call ai if no rate
            // if (result?.data?.length > 0) {
            //     setLoading(false);
            //     setAPIRate(result?.data);
            // } else {
            //     await getLTLQuoteByDeepSeek();
            // }
            setAPIRate(result?.data);
            return result?.data;
        } catch (e) {
            setError(true);
        } finally {
            setLoading(false);
        }
    }

    const handleGetVehicleRating = async (email, phone) => {
        try {
            setLoading(true);

            let requestURL = `${NODE_ROUTE_URI}/movingCar/getMovingCarRatingList`;

            let vehicleList = listData?.map(each => ({
                make: each?.make,
                model: each?.model,
                yearOfProduction: each?.year,
                categoryValue: "",
                quantity: each?.quantity
            }));

            const data = {
                shipFromAddress: "",
                shipFromSubCity: movingFrom?.subCity,
                shipFromCity: movingFrom?.city,
                shipFromProvince: movingFrom?.province,
                shipFromCountry: movingFrom?.country,
                shipFromPostalCode: movingFrom?.postalCode,
                shipToAddress: "",
                shipToSubCity: movingTo?.subCity,
                shipToCity: movingTo?.city,
                shipToProvince: movingTo?.province,
                shipToCountry: movingTo?.country,
                shipToPostalCode: movingTo?.postalCode,
                packageData: vehicleList,
                sendNotifyEmail: true,
                userEmail: email,
                userPhone: phone,
                chatBot: true
            }

            // console.log('[handleGetVehicleRating] data', data);

            const result = await axios({
                method: 'post',
                url: requestURL,
                // headers: {Authorization: `Bearer ${storedToken}`},
                data: data
            })

            console.log('[handleGetVehicleRating] rating result', result);
            // setErrorMessage('');

            // todo call ai if no rate
            // if (+result?.data?.finalTotal > 0) {
            //     setLoading(false);
            //     setAPIRate(result?.data);
            //     setCarRate(result?.data);
            // } else {
            //     await getCarQuoteByDeepSeek();
            // }
            setAPIRate(result?.data);
            return result?.data;
        } catch (e) {
            setError(true);
        } finally {
            setLoading(false);
        }
    }

    const handleGetPackageRatingFromMovingItems = async (packageObject, deepSeekData, movingRating, email, phone) => {
        try {
            setPackageLoading(true);
            let requestURL = `${PARTNER_URI}/loose-item/3rd-party/partner/rates/landing/all`;

            const updatedFurnitureList = deepSeekData?.items?.map(item => ({
                ...item,
                lengthUnit: "in",
                weightUnit: "lb",
                packageSpecialServices: {
                    wrappingService: false,
                    packingService: false,
                    assemblyService: false,
                    disassemblyService: false
                }
            }))

            const additionalService = {
                scheduleDelivery: false,
                whiteGlove: false,
                packingService: false,
                wrappingService: false,
                assemblyService: false,
                disassemblyService: false,
                storageService: {
                    cubicMeterSpace: 0,
                    storageDays: 0
                }
            }

            const specialServices = Object.keys(additionalService)
                .filter(key => typeof additionalService[key] === 'boolean' && additionalService[key])
                .map(serviceName => ({serviceName}));

            let updatedPackageList = [];
            updatedPackageList.push(packageObject);

            const data = {
                rateData: {
                    shipFromAddress: "",
                    shipFromAddressTwo: "",
                    shipFromSubCity: movingFrom?.subCity,
                    shipFromCity: movingFrom?.city,
                    shipFromProvince: movingFrom?.province,
                    shipFromPostalCode: movingFrom?.postalCode,
                    shipFromCountry: movingFrom?.country,
                    shipFromName: "",
                    shipFromPhone: "",
                    shipToAddress: "",
                    shipToAddressTwo: "",
                    shipToSubCity: movingTo?.subCity,
                    shipToCity: movingTo?.city,
                    shipToPostalCode: movingTo?.postalCode,
                    shipToProvince: movingTo?.province,
                    shipToCountry: movingTo?.country,
                    shipToName: "",
                    shipToPhone: "",
                    packageData: updatedPackageList,
                },
                sendNotifyEmail: true,
                userEmail: email,
                userPhone: phone,
                movingReq: {
                    items: updatedFurnitureList,
                    boxList: null,
                    pickupWarehouseId: movingFrom?.warehouse?.id || null,
                    selfDropOff: movingFrom?.option === 'self',
                    pickupAddress: null,
                    pickupSubCity: movingFrom?.subCity,
                    pickupCity: movingFrom?.city,
                    pickupProvince: movingFrom?.province,
                    pickupCountry: movingFrom?.country,
                    pickupPostalCode: movingFrom?.postalCode,
                    deliverWarehouseId: movingTo?.warehouse?.id || null,
                    selfPickup: movingTo?.option === 'self',
                    deliverAddress: null,
                    deliverSubCity: movingTo?.subCity,
                    deliverCity: movingTo?.city,
                    deliverProvince: movingTo?.province,
                    deliverCountry: movingTo?.country,
                    deliverPostalCode: movingTo?.postalCode,
                    specialServices: specialServices,
                    pickupHouseFeatures: {
                        houseType: movingFrom?.propertyType?.houseType === 'Apartment' ? 'Condo' : movingFrom?.propertyType?.houseType,
                        floorLevel: movingFrom?.floorLevel,
                        staircaseNumber: "0",
                        isNarrowStreet: movingFrom?.isNarrowStreet,
                        drivewaySteepLevel: movingFrom?.isSteepDriveway ? 1 : 0,
                        hasLift: !!movingFrom?.lift
                    },
                    deliverHouseFeatures: {
                        houseType: movingTo?.propertyType?.houseType === 'Apartment' ? 'Condo' : movingTo?.propertyType?.houseType,
                        floorLevel: movingTo?.floorLevel,
                        staircaseNumber: "0",
                        isNarrowStreet: movingTo?.isNarrowStreet,
                        drivewaySteepLevel: movingTo?.isSteepDriveway ? 1 : 0,
                        hasLift: !!movingTo?.lift
                    },
                    loadingTime: deepSeekData?.loadingTime,
                    unloadingTime: deepSeekData?.unloadingTime,
                    loadingCost: deepSeekData?.loadingCost,
                    unloadingCost: deepSeekData?.unloadingCost,
                    palletQuantity: +deepSeekData?.pallets,
                    expectedMovingDate: 'Within 2 weeks'
                },
                movingRes: movingRating,
                shipmentTypeGroupId: 8
            }

            const result = await axios({
                method: 'post',
                url: requestURL,
                data: data
            })
            setPackageRate(result?.data);
        } catch (e) {
            setPackageError(true);
        } finally {
            setPackageLoading(false);
        }
    }

    const handleGetMovingRating = async (email, phone) => {
        setLoading(true);
        let requestURL = `${NODE_ROUTE_URI}/movingService/movingItemGetGeneralRatingFromAIWithChatCompletion`;

        // Map to simple strings
        const movingContent = listData?.map(item =>
            `${item.quantity} ${item.description} (${item.length}x${item.width}x${item.height}${item.dimension_unit}, ${item.weight}${item.weight_unit})`
        )?.join('; ');

        const data = {
            content: movingContent,
            selfDropOff: movingInformation?.pickup !== 'Schedule Pickup',
            pickupAddress: null,
            pickupSubCity: movingFrom?.subCity,
            pickupCity: movingFrom?.city,
            pickupProvince: movingFrom?.province,
            pickupCountry: movingFrom?.country,
            pickupPostalCode: movingFrom?.postalCode,
            pickupLatitude: movingFrom?.latitude,
            pickupLongitude: movingFrom?.longitude,
            deliverWarehouseId: movingTo?.warehouse?.id || null,
            selfPickup: movingInformation?.delivery !== 'Schedule Delivery',
            deliverAddress: null,
            deliverSubCity: movingTo?.subCity,
            deliverCity: movingTo?.city,
            deliverProvince: movingTo?.province,
            deliverCountry: movingTo?.country,
            deliverPostalCode: movingTo?.postalCode,
            deliverLatitude: movingTo?.latitude,
            deliverLongitude: movingTo?.longitude,
            pickupHouseFeatures: {
                houseType: movingInformation?.shipper_house_type === 'Apartment' ? 'Condo' : movingFrom?.propertyType?.houseType,
                floorLevel: movingFrom?.floorLevel,
                staircaseNumber: "0",
                isNarrowStreet: movingFrom?.isNarrowStreet,
                drivewaySteepLevel: movingFrom?.isSteepDriveway ? 1 : 0,
                hasLift: !!movingFrom?.lift
            },
            deliverHouseFeatures: {
                houseType: movingInformation?.consignee_house_type === 'Apartment' ? 'Condo' : movingTo?.propertyType?.houseType,
                floorLevel: movingTo?.floorLevel,
                staircaseNumber: "0",
                isNarrowStreet: movingTo?.isNarrowStreet,
                drivewaySteepLevel: movingTo?.isSteepDriveway ? 1 : 0,
                hasLift: !!movingTo?.lift
            },
            userEmail: email,
            userPhone: phone,
            chatBot: true,
            labourNumber: 2,
            expectedMovingDate: movingInformation?.expected_moving_date,
            sendNotifyEmail: true
        }

        try {
            const result = await axios({
                method: 'post',
                url: requestURL,
                data: data
            })

            console.log('[handleGetMovingRating] result', result);

            setAPIRate(result?.data);

            const convertToPackageResult = convertMovingItemsToPackageData(result?.data?.itemsFromAI?.items);

            setIsAbleGetPackageRate(result?.data?.needToCallPackageRating);

            if (result?.data?.needToCallPackageRating) {
                handleGetPackageRatingFromMovingItems(convertToPackageResult?.packageData, result?.data?.itemsFromAI, result?.data, email, phone);
            }

            return result?.data;

        } catch (e) {
            console.log(e.response);
            setError(true);

        } finally {
            setLoading(false);
        }
    }

    const handleGetRatingMap = async (email, phone) => {

        let rating = null;

        switch (service?.code) {
            case PARCEL_PACKAGE?.code:
                rating = await handleGetPackageRating(email, phone);
                return rating;
            case LTL_FREIGHT?.code:
                rating = await handleGetLTLRating(email, phone);
                return rating;
            case MOVING_SERVICE?.code:
                rating = await handleGetMovingRating(email, phone);
                return rating;
            case CAR_SHIPPING?.code:
                rating = await handleGetVehicleRating(email, phone);
                return rating;
            // case 'brokerage':
            //     await handleGetBrokerageRating();
            //     break
            // case 'ftl':
            //     await handleGetFTLRating();
            //     break
            default:
                return true
        }
    }

    const cbAddChatIntoChatHistory = async (chat) => {
        const chatObject = {
            role: "user",
            parts: [
                {
                    text: chat
                }
            ]
        }

        const chatData = [...chatHistory, chatObject];
        setChatHistory(chatData);

        if (status === 2) {

            const trimmedEmailAddress = chat?.trim();
            setEmailAddress(trimmedEmailAddress);

            const data = await validateEmailAddress(trimmedEmailAddress);

            if (data?.valid) {
                // call rating

                setStatus(3);

                if (service?.code === 'MOVING_SERVICE') {
                    const chatObject = {
                        role: "model",
                        parts: [
                            {
                                text: language === 'cn' ? `您的费用估算正在最终确认中。为确保顺利送达，请提供一个有效的电话号码。` : `Your cost estimate is being finalized. To ensure a smooth delivery, please provide a valid phone number.`
                            }
                        ],
                        status: 3,
                    }
                    setChatHistory([...chatData, chatObject]);
                } else {
                    const apiCheckResult = checkAPICallLimit('iframe');
                    setAPICheck(apiCheckResult);
                    if (apiCheckResult?.allowed) {
                        const rating = await handleGetRatingMap(trimmedEmailAddress, phoneNumber);

                        if (rating) {
                            setStatus(4);
                            const chatResponse = {
                                role: "model",
                                parts: [
                                    {
                                        text: language === 'cn' ? `请查阅上方的${service?.nameCN}估算。` : `Please review the estimate ${service?.name} rating above.`
                                    },
                                ],
                                status: 4,
                                data: rating
                            }
                            setChatHistory([...chatData, chatResponse]);
                        }
                    }
                }
            } else {
                const chatResponse = {
                    role: "model",
                    parts: [
                        {
                            text: `${data?.validators?.mx?.reason || data?.validators?.regex?.reason || `${language === 'cn' ? '请提供有效的电子邮箱地址。' : 'Please provide valid email address.'}`}`
                        },
                    ],
                    status: 2
                }

                setChatHistory([...chatData, chatResponse]);
            }
        } else if (status === 3) {
            const trimmedPhoneNumber = chat?.trim();
            setPhoneNumber(trimmedPhoneNumber);
            const contactPhoneCheck = isValidatePhone(trimmedPhoneNumber);

            if (contactPhoneCheck) {
                const apiCheckResult = checkAPICallLimit('iframe');
                setAPICheck(apiCheckResult);
                if (apiCheckResult?.allowed) {
                    const rating = await handleGetRatingMap(emailAddress, trimmedPhoneNumber);

                    if (rating) {
                        setStatus(4);
                        const chatResponse = {
                            role: "model",
                            parts: [
                                {
                                    text: language === 'cn' ? `请查阅上方的${service?.nameCN}估算。` : `Please review the estimate ${service?.name} rating above.`
                                },
                            ],
                            status: 4,
                            data: rating
                        }
                        setChatHistory([...chatData, chatResponse]);
                    }
                }
            } else {
                const chatResponse = {
                    role: "model",
                    parts: [
                        {
                            text: language === 'cn' ? '请提供有效的电话号码。' : 'Please provide valid phone number.'
                        },
                    ],
                    status: 3
                }

                setChatHistory([...chatData, chatResponse]);
            }
        } else {
            // call gemini ai
            const data = await handleMultiConversationChatBot(chatData);
            const chatResponse = {
                role: "model",
                parts: [
                    {
                        text: data?.next_question
                    },
                ],
                data: convertDataFromServiceCode(service?.code, data),
                status: data?.status
            }
            setChatHistory([...chatData, chatResponse]);
        }

        window?.scrollTo({
            top: document.documentElement.scrollHeight,
            behavior: 'smooth'
        });
    }

    const cbStartNewChat = () => {
        setService(null);
        setChatHistory([]);
        setStatus(0);
        setEmailAddress('');
        setPhoneNumber('');
        setError(false);
        setAPIRate(null);
        setMovingInformation(null);
        setPackageRate(null);
        setIsAbleGetPackageRate(false);
        setPackageError(null);
    }

    const cbHandleService = (service) => {
        setService(service);
        setChatHistory([]);
        setStatus(0);
        setEmailAddress('');
        setPhoneNumber('');
        setError(false);
        setAPIRate(null);
        setMovingInformation(null);
        const chatArray = [
            {
                role: "user",
                parts: [
                    {
                        text: language === 'cn' ? service?.nameCN : service?.name
                    }
                ]
            },
            {
                role: "model",
                parts: [
                    {
                        text: language === 'cn' ? service?.promptCN : service?.prompt
                    }
                ],
                status: 0
            }
        ]
        setChatHistory([...chatArray]);
    }

    const cbHandleConfirm = () => {

        const chatArray = [
            {
                role: "user",
                parts: [
                    {
                        text: language === 'cn' ? '确认' : 'Confirm'
                    }
                ]
            },
            {
                role: "model",
                parts: [
                    {
                        text: language === 'cn' ? `您的费用估算正在最终确认中。为确保顺利送达，请提供一个有效的电子邮箱地址。` : `Your cost estimate is being finalized. To ensure a smooth delivery, please provide a valid email address.`
                    }
                ],
                status: 2
            }
        ]

        const chatData = [...chatHistory, ...chatArray];
        setChatHistory(chatData);

        setStatus(2)
    }

    const cbHandleMovingService = async (data) => {
        console.log('[cbHandleMovingService] data', data);

        setService(MOVING_SERVICE);

        const movingService = 'Moving Service';
        const shipFrom = `Ship From: ${data?.data?.shipper_address?.city}, ${data?.data?.shipper_address?.province}, ${data?.data?.shipper_address?.postalCode}, ${data?.data?.shipper_address?.country}`
        const shipTo = `Ship To: ${data?.data?.consignee_address?.city}, ${data?.data?.consignee_address?.province}, ${data?.data?.consignee_address?.postalCode}, ${data?.data?.consignee_address?.country}`
        const itemList = `Item List: ${data?.data?.package?.map((item, index) =>
            `Package ${index + 1}: ${item.length}x${item.width}x${item.height} ${item.dimension_unit}, ${item.weight}${item.weight_unit} (Qty: ${item.quantity})`
        ).join('; ')}`

        console.log('[cbHandleMovingService] shipFrom', shipFrom);
        console.log('[cbHandleMovingService] shipTo', shipTo);
        console.log('[cbHandleMovingService] itemList', itemList);

        const chatArray = [
            {
                role: "user",
                parts: [
                    {
                        text: `${movingService}; ${shipFrom}; ${shipTo}; ${itemList}`
                    }
                ]
            },
        ]

        const chatData = [...chatHistory, ...chatArray];
        setChatHistory(chatData);

        let systemRole = MOVING_SERVICE?.code;

        const movingData = await handleMultiConversationChatBot(chatData, systemRole);

        console.log('[handleMultiConversationChatBot] movingData', movingData);

        const chatResponse = {
            role: "model",
            parts: [
                {
                    text: movingData?.next_question
                },
            ],
            data: convertDataFromServiceCode(systemRole, movingData),
            status: movingData?.status
        }
        setChatHistory([...chatData, chatResponse]);

    }

    useEffect(() => {

        const isChinesePreference = hasChinesePreference();
        const isChineseParams = lng.toLowerCase() === 'cn';

        if (isChinesePreference || isChineseParams) {
            handleLanguageDialogOpen();
        }

    }, [lng]);

    // Auto-scroll to bottom when chatHistory changes
    useEffect(() => {
        if (chatContainerRef.current) {
            chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
        }
    }, [chatHistory]); // Dependency on chatHistory

    console.log('[WordPressMultiConversationChatBot] chatHistory', chatHistory);
    console.log('[WordPressMultiConversationChatBot] status', status);
    console.log('[WordPressMultiConversationChatBot] service', service);
    console.log('[WordPressMultiConversationChatBot] listData', listData);
    console.log('[WordPressMultiConversationChatBot] movingInformation', movingInformation);
    console.log('[WordPressMultiConversationChatBot] movingFrom', movingFrom);

    return (
        <Container maxWidth='xl'>
            <Dialog
                open={openLanguage}
                onClose={handleLanguageDialogClose}
            >
                <DialogTitle>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column'
                    }}>
                        <Typography>
                            Please select your preferred conversation language
                        </Typography>
                        <Typography>
                            请选择您的首选对话语言:
                        </Typography>
                    </Box>
                    {/*{lng === 'cn' ? '请选择您的首选语言' : 'Select Your Preferred Language'}*/}
                </DialogTitle>
                <DialogActions>
                    <Button
                        onClick={() => handleSelectLanguage('en')}
                    >
                        English
                    </Button>
                    <Button
                        onClick={() => handleSelectLanguage('cn')}
                    >
                        中文
                    </Button>
                </DialogActions>
            </Dialog>
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '20px',
                padding: '40px 0px'
            }}>
                <Box
                    ref={chatContainerRef}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        border: `10px solid ${green}`,
                        borderRadius: '10px',
                        padding: '50px 100px',
                        width: '100%',
                        height: '80vh',
                        justifyContent: 'space-between',
                        gap: '50px',
                        overflow: 'auto' // Add this line for scrolling
                    }}>
                    <WordPressMultiConversationChatBotOutput
                        lng={language}
                        status={status}
                        service={service}
                        chatHistory={chatHistory}
                        cbHandleConfirm={cbHandleConfirm}
                        cbHandleMovingService={cbHandleMovingService}
                        packageRate={packageRate}
                        packageLoading={packageLoading}
                        packageError={packageError}
                        isAbleGetPackageRate={isAbleGetPackageRate}
                        movingFrom={movingFrom}
                        movingTo={movingTo}
                        emailAddress={emailAddress}
                        phoneNumber={phoneNumber}
                        APIRate={APIRate}
                    />
                    <WordPressMultiConversationChatBotInput
                        lng={language}
                        loading={loading}
                        service={service}
                        chatHistory={chatHistory}
                        cbHandleService={cbHandleService}
                        cbAddChatIntoChatHistory={cbAddChatIntoChatHistory}
                        cbStartNewChat={cbStartNewChat}
                        APIRate={APIRate}
                    />
                </Box>
            </Box>
        </Container>
    )
}